@use "variables" as *;

.container {
  position: relative;
  display: flex;
  border-radius: 20px !important;
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-m;
  margin-right: $spacing-s;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 70px;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.name {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.isoCode {
  font-size: $fontSize-xxs;
  font-weight: bold;
  white-space: pre-wrap;
  text-align: center;
  margin-top: -5px;
}

.flag {
  font-size: $fontSize-xl;
  white-space: pre-wrap;
  text-align: center;
}
